import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HasuraRoleInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.indexOf('https://graphql') !== -1) {
      // console.log('intercepted');
      const modified = request.clone({
        setHeaders: { 'x-hasura-role': 'public' }
      });
      return next.handle(modified);
    }
    return next.handle(request);
  }
}
